import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantService,
  ParticipantSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto,
} from '../../services/wealthlane-customer-services';

const useGetCompanyLogo = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto | undefined,
  unknown
> => {
  const CompanyLogo = useQuery(['getCompanyLogo'], async () => {
    return await handleRequest(
      ParticipantSharedService.getApiCustomerApiAppParticipantCompanyLogo()
    );
  });

  return CompanyLogo;
};

export default useGetCompanyLogo;
